export default {
  'financeReconciliation.pageTitle': 'Financial Reconciliation',
  'financeReconciliation.bankAccount': 'Bank Account',
  'financeReconciliation.accountPeriod': 'Account Period',
  'financeReconciliation.exportStatement': 'Export Statement',
  'financeReconciliation.monthlyStatement': 'Monthly Statement',
  'financeReconciliation.statementPeriod': 'Statement Period',
  'financeReconciliation.opening': 'Opening Balance',
  'financeReconciliation.credit': 'Credit (Income)',
  'financeReconciliation.debit': 'Debit (Expense)',
  'financeReconciliation.closing': 'Closing Balance',
  'financeReconciliation.transactionDate': 'Transaction Date',
  'financeReconciliation.description': 'Description / Counterparty',
  'financeReconciliation.debitOut': 'Debit (OUT)',
  'financeReconciliation.creditIn': 'Credit (IN)',
  'financeReconciliation.balance': 'Balance (BAL)',
  'financeReconciliation.totalSummary': 'TOTAL SUMMARY',
  'financeReconciliation.createdTime': 'Created Time',
  'financeReconciliation.poweredBy': 'Powered by SmartReconcile',
  'financeReconciliation.selectBankAccount': 'Please select bank account',
  'financeReconciliation.selectAccountPeriod': 'Please select account period',
};
